import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/functions';

// firebase init goes here
const config = {
    apiKey: "AIzaSyDRlZ30lRlNt-Q20dQaZ1o5Jf9e85Yvlqg",
    authDomain: "bodytone-app.firebaseapp.com",
    databaseURL: "https://bodytone-app.firebaseio.com",
    projectId: "bodytone-app",
    storageBucket: "bodytone-app.appspot.com",
    messagingSenderId: "747374721634"
}

 var app = firebase.initializeApp(config)

// firebase utils
const fs = app.firestore() //firestore database
const auth = app.auth()
const fn = app.functions();
const credentials = firebase.auth.EmailAuthProvider;
const currentUser = auth.currentUser
const storage = app.storage().ref();

const settings = {
    timestampsInSnapshots: true
}
fs.settings(settings)

// firebase collections
const usersCollection = fs.collection('users')
const sessionsCollection = fs.collection('sessions')
const stravaCollection = fs.collection('strava')
const trainingymCollection = fs.collection('trainingym')

export {
    auth,
    fn,
    currentUser,
    usersCollection,
    sessionsCollection,
    stravaCollection,
    trainingymCollection,
    storage,
    googleMapsKey,
    credentials
}


// WEBPACK FOOTER //
// ./src/firebaseConfig.js